import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { useDispatch, useSelector } from "react-redux";
import { droneApi } from "./api";
import fleetReducer from "./fleetSlice";

export const store = configureStore({
  reducer: {
    [droneApi.reducerPath]: droneApi.reducer,
    fleet: fleetReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(droneApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export * from "./fleetSlice";
export * from "./api";
